import { ListSubheader, Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export type LegendSectionTitleProps = {
  children: ReactNode;
  subtitle?: ReactNode;
  endAdornment?: ReactNode;
  titleSx?: SxProps<Theme>;
  showDivider?: boolean;
  sx?: SxProps<Theme>;
};

export const LegendSectionTitle = (
  props: LegendSectionTitleProps,
): JSX.Element => {
  const {
    children,
    subtitle,
    endAdornment,
    titleSx,
    showDivider = true,
    sx = [],
  } = props;

  return (
    <ListSubheader
      color="inherit"
      disableSticky
      sx={[
        (theme) => ({
          padding: theme.spacing(3, 2, 1),
          lineHeight: 1,
          mb: 2,
          ...(showDivider && {
            borderBottom: `1px solid ${theme.palette.divider}`,
          }),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack spacing={subtitle ? 0.5 : 0}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            variant="h3"
            sx={{ fontWeight: 'fontWeightBold', ...titleSx }}
          >
            {children}
          </Typography>
          {endAdornment}
        </Stack>
        {subtitle ? (
          <Typography variant="caption" component="div">
            {subtitle}
          </Typography>
        ) : null}
      </Stack>
    </ListSubheader>
  );
};
